<mat-dialog-content>
  <div class="modalWrapper">
    <button class="cmn-close" (click)="onNoClick()"></button>

    <div class="headerClass">
      <h3>{{ data?.id ? 'Edit Role' : 'Create New Role' }}</h3>
    </div>

    <form #form="ngForm" (ngSubmit)="onSubmit(form)">
      <div class="form-wrapper">
        <mat-form-field>
          <mat-label>Role</mat-label>
          <input
            matInput
            name="name"
            [(ngModel)]="model.name"
            placeholder="Enter role"
            required
            maxlength="51"
            noOnlySpaces
            noOnlySpecialAlphaChars
            #name="ngModel"
            pattern="^[\s\S]{0,50}$"
          />
          <mat-error *ngIf="name.errors?.['required'] && name.touched">
            Role is required
          </mat-error>
          <mat-error *ngIf="name.errors?.['pattern'] && name.touched">
            Role must be under 50 characters
          </mat-error>
          <mat-error *ngIf="name.errors?.['onlySpaces'] && name.touched">
            Role cannot be only spaces.
          </mat-error>
          <mat-error *ngIf="name.errors?.['onlySpecialAlphaChars'] && name.touched">
            Role cannot be only special characters or numbers
          </mat-error>

        </mat-form-field>

        <mat-form-field>
          <mat-label>Description</mat-label>
          <input
            matInput
            name="description"
            [(ngModel)]="model.description"
            placeholder="Enter Description"
            required
            maxlength="151"
            #description="ngModel"
            noOnlySpaces
            noOnlySpecialAlphaChars
            pattern="^[\s\S]{0,150}$"
          />
          <mat-error *ngIf="description.errors?.['required'] && description.touched">
            Description is required
          </mat-error>
          <mat-error *ngIf="description.errors?.['pattern'] && description.touched">
            Description must be under 150 characters
          </mat-error>
          <mat-error *ngIf="description.errors?.['onlySpaces'] && description.touched">
            Description cannot be only spaces.
          </mat-error>
          <mat-error *ngIf="description.errors?.['onlySpecialAlphaChars'] && description.touched">
            Description cannot be only special characters or numbers
          </mat-error>
        </mat-form-field>
      </div>

      <button [disabled]="isSubmitting" type="submit" class="cmn-profile-btn">
        {{ data?.id ? 'Update Role' : 'Add Role' }}
      </button>
    </form>
  </div>
</mat-dialog-content>
